/**
CREATIVE CODING
---
Kill server : CTRL + C
Start server : npm run start
Final build : npm run build
---
**/

import AxL from "./axl";

import * as THREE from "three";
// add custom orbit controls
import { OrbitControls } from "./controls/OrbitControls.js";

import Letter from "./JumpingLetter";
import { createNoise2D } from "simplex-noise";
import Utils from "./Utils";
// import Texture from "./Texture";
import RemoteTexture from "./RemoteTexture";
import GlobalColorSingleton from "./GlobalColor";
import Recorder from "./Recorder";
import Playback from "./Playback";
import UI from "./UI";

// import tween correctly
import * as TWEEN from "@tweenjs/tween.js";
// import Playbutton from "./Playbutton";

import Game from "./Game";
import Errorsinterface from "./Errorsinterface";
import AudioEffects from "./AudioEffects";

// state machine
import Statemachine from "./Statemachine";
//
import Tooltips from "./Tooltips";
//
import Title from "./Title";
import AboutPage from "./AboutPage";
//
// import DraggableModal from "./DraggableModal";
import FinishModal from "./FinishModal";
import ResumeOverlay from "./ResumeOverlay";
//
import MobileDetector from "./MobileDetector";
import MobileKeyboard from "./MobileKeyboard";
// tracking
import Tracking from "./Tracking";
// config
import Config from "./Config";
import DOMConfigurator from "./DOMConfigurator";
// DEBUG
// GAME IS ACTIVE WHEN FALSE
const BASIC_TYPEWRITER = false;
const DEBUG = false;

export default class App {
  constructor() {
    console.log(
      "%c ✨ CANVAS EXPERIMENT ✨ ",
      "background: #000; color: #f0f; padding:10px;"
    );
    console.log("IS MOBILE : ", MobileDetector.isMobile);
    console.log("IS Tablet : ", MobileDetector.isTablet);
    console.log("IS PORTRAIT : ", MobileDetector.isPortrait);
    // if (FILTERED_VERSION) {
    //   this.PATH = {
    //     getTypography: "getTypographyFiltered/",
    //     getChoicesTotal: "getChoicesTotalFiltered/",
    //   };
    // } else {
    //   this.PATH = {
    //     getTypography: "getTypography/",
    //     getChoicesTotal: "getChoicesTotal/",
    //   };
    // }
    const urlParams = new URLSearchParams(window.location.search);
    this.IS_INLINE = urlParams.get("inline");
    let lang = urlParams.get("lang") || "en";
    this.languages = [
      "en",
      "fr",
      // "es-419",
      // "es",
      // "hi",
      // "it",
      // "ja",
      // "pt-BR",
      // "pt-PT",
      // "zh-CN",
      // "zh-TW",
      // "zh-HK",
      // "pl",
      // "in",
      // "ko",
      // "ms",
      // "th",
      // "vi",
      // "cs",
    ];
    let isLangSupported = this.languages.includes(lang);
    if (!isLangSupported) {
      lang = "en";
    }
    Config.language = lang;
    this.prepareApp();
    // ////AXL
    // this.axl = new AxL();
    // if (window._y010) {
    //   // this.sharedData = {
    //   //   index: 315,
    //   //   message: "Can you guess that word by looking at the letters ?",
    //   // };
    //   this.initApp();
    //   // this.initAxL();
    // } else {
    //   this.initAxL();
    // }
  }

  async prepareApp() {
    Config.dictionary = await Utils.loadJSON(
      `json/translations/translation_${Config.language}.json`
    );
    await this.preloadThreeScene();
    new DOMConfigurator(Config.dictionary);
    ////AXL
    this.axl = new AxL();
    if (window._y010) {
      // this.sharedData = {
      //   index: 296,
      //   message: "Can you guess that word by looking at the letters ?",
      // };
      this.draw();
      this.initApp();
      // this.initAxL();
    } else {
      this.initAxL();
    }
  }

  async initAxL() {
    //--------- PRELOAD OPTIONS HERE
    //------------
    let firstResume = true;
    const gotFirstResume = new Promise((resolve) => {
      this.axl.registerMessageCallback(AxL.HostToChild.RESUME, (payload) => {
        console.log("init RESUME ");
        if (firstResume) {
          firstResume = false;
          resolve();
        } else {
          console.log("RESUME");
          // AudioEffects.mute = false;
          // if (Statemachine.state.state == "intro_sequence_playing")
          //   this.onUIActions("playResume");
          // // this.activateTypeWriter();
          // document.addEventListener("keydown", this.handlers.down);
          // // should activate rendering
          // this.PAUSE = false;
          // this.draw();
          if (!this.IS_INLINE) this.onResume();
        }
      });
    });

    // add freez callback
    const gameFreeze = this.axl.registerMessageCallback(
      AxL.HostToChild.FREEZE,
      () => {
        if (this.IS_INLINE) this.resumeOverlay.show();
        AudioEffects.mute = true;
        if (Statemachine.state.state == "intro_sequence_playing")
          this.onUIActions("pauseFreeze");
        // this.deactivateTypeWriter();
        document.removeEventListener("keydown", this.handlers.down);
        // should stop rendering
        this.PAUSE = true;
      }
    );

    const gameReady = this.axl.handshake().then((initialData) => {
      try {
        console.log("handshake is done", initialData);
        this.AXL_IS_RUNNING = true;
        // let objJsonStr = JSON.stringify(initialData);
        // let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
        // console.log(objJsonB64);
        this.tracker = new Tracking(this.axl);
        if (initialData) {
          this.sharedData = initialData;
        }
        this.draw();
      } catch (error) {
        console.log("ERROR", error);
      }
    });

    // Make sure game is initialized AND we got the first resume call
    Promise.all([gotFirstResume, gameFreeze, gameReady]).then(() => {
      console.log("init app");
      this.initApp();
    });
  }

  onResume() {
    if (this.IS_INLINE) this.resumeOverlay.hide();
    AudioEffects.mute = false;
    if (Statemachine.state.state == "intro_sequence_playing")
      this.onUIActions("playResume");
    // this.activateTypeWriter();
    document.addEventListener("keydown", this.handlers.down);
    // should activate rendering
    this.PAUSE = false;
    this.draw();
  }

  async initApp() {
    // init TEXTURES ....
    // const choices = await Utils.loadJSON("getChoicesTotal/");
    const choices = await Utils.loadJSON(Config.getChoicesTotal);
    this.KEYWORD_INDEXES = Utils.createArrayOfNumbers(parseInt(choices.total));
    this.KEYWORD_INDEXES = Utils.suffleArray(this.KEYWORD_INDEXES);
    // console.log("first KEYWORD_INDEXES", this.KEYWORD_INDEXES);
    // console.log("shared data", this.sharedData);

    // DEBUG FORCE KEYWORD
    // this.KEYWORD_INDEXES.unshift(272);

    // GAME COMING FROM SHARE
    if (
      this.sharedData &&
      this.sharedData.index != null &&
      this.sharedData.index != undefined
    ) {
      this.KEYWORD_INDEXES = Utils.putValueAtFirstPosition(
        this.KEYWORD_INDEXES,
        this.sharedData.index
      );
    }
    // console.log("second KEYWORD_INDEXES", this.KEYWORD_INDEXES);
    let texture = new RemoteTexture(
      `${Config.getTypography}${this.KEYWORD_INDEXES.shift()}`,
      /*`getTypography/${this.KEYWORD_INDEXES.shift()}`,*/
      1
    );
    this.ALL_TEXTURES = await texture.load();
    if (!DEBUG) {
      this._keyword = Utils.translate(texture.KEYWORD, Config.dictionary);
      this._index = texture.INDEX;
      this.ASSET_ID = texture.ASSET_ID;
      this.LINK = texture.LINK;
      // this.HERO = texture.HERO;
    }
    // update content
    this.finishModal.updateContent(this.ASSET_ID, this._keyword, this.LINK);
    // load all audio files
    AudioEffects.start();

    // start draw()
    // this.draw();
  }

  preloadThreeScene() {
    return new Promise(async (resolve) => {
      // const choices = await Utils.loadJSON("getChoicesTotal/");
      // this.KEYWORD_INDEXES = Utils.createArrayOfNumbers(
      //   parseInt(choices.total)
      // );
      // this.KEYWORD_INDEXES = Utils.suffleArray(this.KEYWORD_INDEXES);
      // console.log("first KEYWORD_INDEXES", this.KEYWORD_INDEXES);
      // console.log("shared data", this.sharedData);
      // // GAME COMING FROM SHARE
      // if (this.sharedData && this.sharedData.index) {
      //   this.KEYWORD_INDEXES = Utils.putValueAtFirstPosition(
      //     this.KEYWORD_INDEXES,
      //     this.sharedData.index
      //   );
      // }
      // console.log("second KEYWORD_INDEXES", this.KEYWORD_INDEXES);
      this.hasUsedKeyboard =
        MobileDetector.isMobile || MobileDetector.isTablet ? true : false;
      this.size = {
        width: window.innerWidth,
        height: MobileDetector.isPortrait
          ? window.innerHeight / 2
          : window.innerHeight,
      };

      this.scene = new THREE.Scene();
      if (MobileDetector.isMobile || MobileDetector.isTablet)
        this.mobileKeyboard = new MobileKeyboard(MobileDetector.isPortrait);

      // create an isometric camera with a 180 degree field of view 16
      const aspect = MobileDetector.isMobile ? 6 : 16;
      this.camera = new THREE.OrthographicCamera(
        this.size.width / -aspect,
        this.size.width / aspect,
        this.size.height / aspect,
        this.size.height / -aspect,
        0.1,
        1000
      );

      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(this.size.width, this.size.height);
      this.renderer.shadowMap.enabled = true;
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.canvas = this.renderer.domElement;
      document.body.appendChild(this.renderer.domElement);

      // add new letter
      this.allLetters = [];
      this.onlyLettersWithTexture = [];
      this.noise2D = createNoise2D();
      this.otherElementToBeRemoved = [];

      this.targetElement = this.scene;

      this.camera.position.y = 130; //60
      this.camera.position.x = 30;

      // add some lights
      this._light = new THREE.AmbientLight(0x505050); // soft white light
      this.scene.add(this._light);
      // add spotlight for the shadows
      this.light = new THREE.SpotLight(0xffffff, 1, 500);
      this.light.intensity = 9;
      this.light.position.set(0, 300, 0);

      // add spotlight helper
      this.lightHelper = new THREE.SpotLightHelper(this.light);

      // add a light target
      this.lightTarget = new THREE.Object3D();
      this.lightTarget.position.set(0, 0, -500);
      this.scene.add(this.lightTarget);

      this.light.target = this.lightTarget;
      this.light.target.updateMatrixWorld();

      // cast shadow
      this.light.castShadow = true;
      // set shadow map size
      this.light.shadow.mapSize.width = 1024;
      this.light.shadow.mapSize.height = 1024;
      // set shadow camera near and far
      this.light.shadow.camera.near = 0.5;
      this.light.shadow.camera.far = 500;

      this.scene.add(this.light);

      // add orbit controls
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enablePan = false;
      this.controls.enableRotate = false;
      this.controls.enableDamping = false;
      this.controls.enableZoom = false;
      this.controls.target.set(-14, 0, -200);
      // set max an min zoom distance for the camera
      this.controls.maxZoom = 4;
      this.controls.minZoom = 1;

      const viewWidth = this.camera.right - this.camera.left;
      const viewHeight = this.camera.top - this.camera.bottom;
      if (!BASIC_TYPEWRITER) {
        this.title = new Title(
          viewWidth,
          viewHeight,
          this.scene,
          this.controls
        );
        await this.title.load();
      }
      this.aboutPage = new AboutPage();
      this.resumeOverlay = new ResumeOverlay("resume-overlay", "resume-button");

      // init tooltips
      this.toolTips = new Tooltips(
        MobileDetector.isMobile || MobileDetector.isTablet
      );

      // add a floor plane that will cas the shadow
      this.planeGeometry = new THREE.PlaneGeometry(1000, 1000, 32);
      this.planeMaterial = new THREE.MeshPhongMaterial({
        color: GlobalColorSingleton.color,
        side: THREE.DoubleSide,
      });
      document.body.style.backgroundColor = `#${GlobalColorSingleton.color.toString(
        16
      )}`;

      this.plane = new THREE.Mesh(this.planeGeometry, this.planeMaterial);
      this.plane.rotation.x = Math.PI / 2;
      this.plane.position.y = -10;
      // cast shadow
      this.plane.receiveShadow = true;
      this.plane.name = "plane";
      this.scene.add(this.plane);

      this.KEY_COUNTER = 0;
      this.KEY_COUNTER_OFFSET = Infinity;
      this.CANCEL_BLOCKER = false;
      this.speed = 0.05;

      this.camera.futurePosition = this.camera.position.x;
      this.light.futurePosition = this.light.position.x;
      this.controls.target.futurePosition = this.controls.target.x;
      this.lightTarget.futurePosition = this.lightTarget.position.x;
      this.plane.futurePosition = this.plane.position.x;

      // add raycaster
      this.raycaster = new THREE.Raycaster();
      this.mouse = new THREE.Vector2();

      // let texture = new RemoteTexture(
      //   `getTypography/${this.KEYWORD_INDEXES.shift()}`,
      //   1
      // );
      // this.ALL_TEXTURES = await texture.load();
      // if (!DEBUG) {
      //   this._keyword = texture.KEYWORD;
      //   this._index = texture.INDEX;
      //   this.ASSET_ID = texture.ASSET_ID;
      // }

      this.moveCameraAndLightOnX(-50);
      this.initListeners();
      // this.draw();
      // UI.show("about");
      resolve();
    });
  }

  resize() {
    this.size = {
      width: window.innerWidth,
      height: MobileDetector.isPortrait
        ? window.innerHeight / 2
        : window.innerHeight,
    };
    const aspect = this.size.width / this.size.height;
    const viewSize = 120;
    this.camera.left = (-aspect * viewSize) / 2;
    this.camera.right = (aspect * viewSize) / 2;
    this.camera.top = viewSize / 2;
    this.camera.bottom = -viewSize / 2;

    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.size.width, this.size.height);

    //
    const viewWidth = this.camera.right - this.camera.left;
    const viewHeight = this.camera.top - this.camera.bottom;
    if (this.title) this.title.resize(viewWidth, viewHeight);
    if (this.mobileKeyboard)
      this.mobileKeyboard.resize(MobileDetector.isPortrait);
  }

  // async init() {
  //   const choices = await Utils.loadJSON("getChoicesTotal/");
  //   this.KEYWORD_INDEXES = Utils.createArrayOfNumbers(parseInt(choices.total));
  //   this.KEYWORD_INDEXES = Utils.suffleArray(this.KEYWORD_INDEXES);
  //   // GAME COMING FROM SHARE
  //   if (this.sharedData && this.sharedData.index) {
  //     this.KEYWORD_INDEXES = Utils.putValueAtFirstPosition(
  //       this.KEYWORD_INDEXES,
  //       this.sharedData.index
  //     );
  //   }

  //   // // this.IS_PLAYBACK = false;
  //   // // avoid 2
  //   // const TYPE = !DEBUG ? 8 : 1;
  //   // let texture = null;
  //   // switch (TYPE) {
  //   //   case 1:
  //   //     GlobalColorSingleton.color = 0x333333;
  //   //     GlobalColorSingleton.planeColor = 0x444f44;
  //   //     this._keyword = "aurora";
  //   //     texture = new Texture(
  //   //       "json/machine_new.json",
  //   //       "images/smaller_machine",
  //   //       8
  //   //     );
  //   //     break;
  //   //   case 2:
  //   //     // not so good
  //   //     GlobalColorSingleton.color = 0xc3d4e4;
  //   //     GlobalColorSingleton.planeColor = 0x6e9bc6;
  //   //     texture = new Texture("json/draps_new.json", "images/smaller_draps", 8);
  //   //     break;
  //   //   case 3:
  //   //     GlobalColorSingleton.color = 0xacd2d4;
  //   //     GlobalColorSingleton.planeColor = 0xa9916f;
  //   //     texture = new Texture(
  //   //       "json/island_new.json",
  //   //       "images/smaller_island",
  //   //       8
  //   //     );
  //   //     break;

  //   //   case 4:
  //   //     GlobalColorSingleton.color = 0x111111;
  //   //     GlobalColorSingleton.planeColor = 0x3f3333;
  //   //     texture = new Texture(
  //   //       "json/skulls_new.json",
  //   //       "images/smaller_skulls",
  //   //       8
  //   //     );
  //   //     break;
  //   //   case 5:
  //   //     GlobalColorSingleton.color = 0x1d1724;
  //   //     GlobalColorSingleton.planeColor = 0x6a7d59;
  //   //     texture = new Texture(
  //   //       "json/flowers2.json",
  //   //       "images/smaller_flowers2",
  //   //       8
  //   //     );
  //   //     break;
  //   //   case 6:
  //   //     GlobalColorSingleton.color = 0xededed;
  //   //     GlobalColorSingleton.planeColor = 0xa9916f;
  //   //     texture = new Texture("json/shelf.json", "images/smaller_shelf", 8);
  //   //     break;
  //   //   default:
  //   //     // texture = new Texture("json/nemo_new.json", "images/smaller_nemo", 8);
  //   //     texture = new RemoteTexture(
  //   //       `getTypography/${this.KEYWORD_INDEXES.shift()}`,
  //   //       1
  //   //     );
  //   // }

  //   // this.ALL_TEXTURES = await texture.load();
  //   // if (!DEBUG) {
  //   //   this._keyword = texture.KEYWORD;
  //   //   this._index = texture.INDEX;
  //   //   this.ASSET_ID = texture.ASSET_ID;
  //   // }
  //   // GlobalColorSingleton.setNewColors();

  //   // get the input field to activate the mobile keyboard
  //   // this.keyboard_activator = document.getElementById("activator");

  //   // this.loadAudios();
  //   // this.falling = await this.loadSingleAudio("sound/falling3.mp3");
  //   // console.log(this.falling);

  //   this.scene = new THREE.Scene();

  //   // create an isometric camera with a 180 degree field of view
  //   const aspect = 16;
  //   this.camera = new THREE.OrthographicCamera(
  //     window.innerWidth / -aspect,
  //     window.innerWidth / aspect,
  //     window.innerHeight / aspect,
  //     window.innerHeight / -aspect,
  //     0.1,
  //     1000
  //   );

  //   this.renderer = new THREE.WebGLRenderer({ antialias: true });
  //   this.renderer.setSize(window.innerWidth, window.innerHeight);
  //   this.renderer.shadowMap.enabled = true;
  //   this.renderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap

  //   // this.resize();

  //   document.body.appendChild(this.renderer.domElement);

  //   // add new letter
  //   this.allLetters = [];
  //   this.onlyLettersWithTexture = [];
  //   this.noise2D = createNoise2D();
  //   this.otherElementToBeRemoved = [];

  //   this.targetElement = this.scene;

  //   this.camera.position.y = 130; //60
  //   this.camera.position.x = 30;

  //   // add some lights
  //   this._light = new THREE.AmbientLight(0x505050); // soft white light
  //   this.scene.add(this._light);
  //   // add spotlight for the shadows
  //   this.light = new THREE.SpotLight(0xffffff, 1, 500);
  //   this.light.intensity = 9;
  //   this.light.position.set(0, 300, 0);

  //   // add spotlight helper
  //   this.lightHelper = new THREE.SpotLightHelper(this.light);

  //   // add a light target
  //   this.lightTarget = new THREE.Object3D();
  //   this.lightTarget.position.set(0, 0, -500);
  //   this.scene.add(this.lightTarget);

  //   this.light.target = this.lightTarget;
  //   this.light.target.updateMatrixWorld();

  //   // cast shadow
  //   this.light.castShadow = true;
  //   // set shadow map size
  //   this.light.shadow.mapSize.width = 1024;
  //   this.light.shadow.mapSize.height = 1024;
  //   // set shadow camera near and far
  //   this.light.shadow.camera.near = 0.5;
  //   this.light.shadow.camera.far = 500;

  //   this.scene.add(this.light);

  //   // add orbit controls
  //   this.controls = new OrbitControls(this.camera, this.renderer.domElement);
  //   this.controls.enablePan = false;
  //   this.controls.enableRotate = false;
  //   this.controls.enableDamping = false;
  //   this.controls.enableZoom = false;
  //   this.controls.target.set(-14, 0, -200);
  //   // set max an min zoom distance for the camera
  //   this.controls.maxZoom = 4;
  //   this.controls.minZoom = 1;

  //   const viewWidth = this.camera.right - this.camera.left;
  //   const viewHeight = this.camera.top - this.camera.bottom;
  //   this.title = new Title(viewWidth, viewHeight, this.scene, this.controls);
  //   await this.title.load();

  //   // add a floor plane that will cas the shadow
  //   this.planeGeometry = new THREE.PlaneGeometry(1000, 1000, 32);
  //   this.planeMaterial = new THREE.MeshPhongMaterial({
  //     color: GlobalColorSingleton.color,
  //     side: THREE.DoubleSide,
  //   });

  //   this.plane = new THREE.Mesh(this.planeGeometry, this.planeMaterial);
  //   this.plane.rotation.x = Math.PI / 2;
  //   this.plane.position.y = -10;
  //   // cast shadow
  //   this.plane.receiveShadow = true;
  //   this.plane.name = "plane";
  //   this.scene.add(this.plane);

  //   this.KEY_COUNTER = 0;
  //   this.KEY_COUNTER_OFFSET = Infinity;
  //   this.CANCEL_BLOCKER = false;
  //   this.speed = 0.05;
  //   this.camera.futurePosition = this.camera.position.x;
  //   this.light.futurePosition = this.light.position.x;
  //   this.controls.target.futurePosition = this.controls.target.x;
  //   this.lightTarget.futurePosition = this.lightTarget.position.x;
  //   this.plane.futurePosition = this.plane.position.x;

  //   // add raycaster
  //   this.raycaster = new THREE.Raycaster();
  //   this.mouse = new THREE.Vector2();

  //   // /**
  //   //  * if there is initial data, add a play button
  //   //  * this is a legacy code, it should be removed
  //   //  */
  //   // if (this.initialData && this.initialData.timings) {
  //   //   // add a play button
  //   //   this.button = new Playbutton();
  //   //   this.button.position.z = -200;
  //   //   this.scene.add(this.button);
  //   // }

  //   // // add the Game
  //   // if (!BASIC_TYPEWRITER) {
  //   //   this.game = new Game();
  //   // } else {
  //   //   this.errorsinterface = new Errorsinterface(
  //   //     this.scene,
  //   //     5,
  //   //     this.plane.position.x
  //   //   );
  //   // }

  //   // if (this.game && !this.initialData) {
  //   //   this.button = new Playbutton();
  //   //   this.button.position.z = -200;
  //   //   this.scene.add(this.button);
  //   //   this.initialData = this.game.initialData;
  //   //   console.log("INTIAL DATA", this.initialData);
  //   // }

  //   // console.log(this.planeMaterial.color.getHexString());

  //   /**
  //    *
  //    * TEXTURE LOADER
  //    *
  //    *
  //    */

  //   // this.IS_PLAYBACK = false;
  //   // avoid 2
  //   const TYPE = !DEBUG ? 8 : 1;
  //   let texture = null;
  //   switch (TYPE) {
  //     case 1:
  //       GlobalColorSingleton.color = 0x333333;
  //       GlobalColorSingleton.planeColor = 0x444f44;
  //       this._keyword = "aurora";
  //       texture = new Texture(
  //         "json/machine_new.json",
  //         "images/smaller_machine",
  //         8
  //       );
  //       break;
  //     case 2:
  //       // not so good
  //       GlobalColorSingleton.color = 0xc3d4e4;
  //       GlobalColorSingleton.planeColor = 0x6e9bc6;
  //       texture = new Texture("json/draps_new.json", "images/smaller_draps", 8);
  //       break;
  //     case 3:
  //       GlobalColorSingleton.color = 0xacd2d4;
  //       GlobalColorSingleton.planeColor = 0xa9916f;
  //       texture = new Texture(
  //         "json/island_new.json",
  //         "images/smaller_island",
  //         8
  //       );
  //       break;

  //     case 4:
  //       GlobalColorSingleton.color = 0x111111;
  //       GlobalColorSingleton.planeColor = 0x3f3333;
  //       texture = new Texture(
  //         "json/skulls_new.json",
  //         "images/smaller_skulls",
  //         8
  //       );
  //       break;
  //     case 5:
  //       GlobalColorSingleton.color = 0x1d1724;
  //       GlobalColorSingleton.planeColor = 0x6a7d59;
  //       texture = new Texture(
  //         "json/flowers2.json",
  //         "images/smaller_flowers2",
  //         8
  //       );
  //       break;
  //     case 6:
  //       GlobalColorSingleton.color = 0xededed;
  //       GlobalColorSingleton.planeColor = 0xa9916f;
  //       texture = new Texture("json/shelf.json", "images/smaller_shelf", 8);
  //       break;
  //     default:
  //       // texture = new Texture("json/nemo_new.json", "images/smaller_nemo", 8);
  //       texture = new RemoteTexture(
  //         `getTypography/${this.KEYWORD_INDEXES.shift()}`,
  //         1
  //       );
  //   }

  //   this.ALL_TEXTURES = await texture.load();
  //   if (!DEBUG) {
  //     this._keyword = texture.KEYWORD;
  //     this._index = texture.INDEX;
  //     this.ASSET_ID = texture.ASSET_ID;
  //   }
  //   // GlobalColorSingleton.setNewColors();
  //   /**
  //    *
  //    *
  //    *
  //    *
  //    */

  //   this.moveCameraAndLightOnX(-50);
  //   this.initListeners();
  //   this.draw();
  // }
  initListeners() {
    // const viewWidth = this.camera.right - this.camera.left;
    // const viewHeight = this.camera.top - this.camera.bottom;
    // this.title = new Title(viewWidth, viewHeight, this.scene, this.controls);
    // add orientation listener
    MobileDetector.addEventListener("orientationchange", (value) => {
      console.log("orientationchange", value);
      // this.toolTips.updateBottom(value);

      this.resize();
    });

    // add window listener
    window.addEventListener("resize", () => {
      this.resize();
    });

    this.handlers = {
      down: this.onKeyDown.bind(this),
      ready: this.onReady.bind(this),
      play: this.onPlay.bind(this),
      move: this.onMouseMove.bind(this),
      click: this.onMouseClick.bind(this),
      up: this.onMouseUp.bind(this),
      mDown: this.onMouseDown.bind(this),
      share: this.onShare.bind(this),
      complete: this.onComplete.bind(this),
      gameReady: this.onGameReady.bind(this),
      gameSetupIsComplete: this.onCompleteGameSetup.bind(this),
      playGameSetupSequence: this.playGameSetupSequence.bind(this),
      wheel: this.onWheel.bind(this),
      audioReady: this.onAudioReady.bind(this),
      gameWin: this.onGameWin.bind(this),
      gameOver: this.onGameOver.bind(this),
      uiActions: this.onUIActions.bind(this),
      startIntroSequence: this.onStartIntroSequence.bind(this),
      navigateToAsset: this.onNavigateToAsset.bind(this),
      mobileKeyDown: this.onKeyDown.bind(this),
      titleStart: this.onTitleStart.bind(this),
      aboutLink: this.onAboutLink.bind(this),
      resume: this.onResume.bind(this),
    };

    this.recorder = new Recorder();

    // this.draggableModal = new DraggableModal(this.ASSET_ID, this._keyword);
    // this.draggableModal.addEventListener(
    //   "click",
    //   this.handlers.navigateToAsset
    // );
    this.finishModal = new FinishModal();
    this.finishModal.addEventListener(
      "learnMore",
      this.handlers.navigateToAsset
    );
    this.finishModal.addEventListener("share", this.handlers.share);
    this.finishModal.addEventListener("next", () => {
      // if (this.tracker)
      //   this.tracker.track("NEXT_WORD", this.NEW_TEXTURES.keyword);
      this.onUIActions("continue");
    });
    // this.finishModal.updateContent(this.ASSET_ID, this._keyword);

    this.resumeOverlay.addEventListener("click", this.handlers.resume);

    // add all special keys
    this.specialKeys = [
      "Shift",
      "Meta",
      "Alt",
      "Tab",
      "CapsLock",
      "Control",
      "Dead",
      "ArrowLeft",
      "ArrowDown",
      "ArrowUp",
      "ArrowRight",
    ];

    // set a typing blocker
    this.TYPING_BLOCKER = false;

    if (BASIC_TYPEWRITER == true) {
      document.addEventListener("keydown", this.handlers.down);
    }
    if (this.title) {
      this.title.addEventListener("removed", this.handlers.startIntroSequence);
      this.title.addEventListener("click", this.handlers.titleStart);
    }
    //
    this.aboutPage.addEventListener("click", this.handlers.aboutLink);

    // mobile keyboard
    if (this.mobileKeyboard) {
      this.mobileKeyboard.addEventListener(
        "keydown",
        this.handlers.mobileKeyDown
      );
    }

    // this.activateTypeWriter();
    this.canvas.addEventListener("mousemove", this.handlers.move);
    this.canvas.addEventListener("click", this.handlers.click);
    this.canvas.addEventListener("mousedown", this.handlers.mDown);
    this.canvas.addEventListener("mouseup", this.handlers.up);
    this.canvas.addEventListener("wheel", this.handlers.wheel);

    // addd UI listeners
    UI.addEventListener("click", this.handlers.uiActions);

    AudioEffects.addEventListener("ready", this.handlers.audioReady);
    // AudioEffects.start();
  }

  onAboutLink(link) {
    if (this.AXL_IS_RUNNING) {
      this.axl.sendMessage(AxL.ChildToHost.NAVIGATE, link);
    } else {
      console.log("LINK clicked", link);
    }
  }

  onTitleStart(e) {
    this.INTERSECTED = { name: "playbutton" };
    this.onMouseUp(e);
    if (this.tracker) this.tracker.track("START_CLICK");
  }

  onAudioReady(e) {
    console.log("**AUDIO**READY");
    // add the Game
    if (BASIC_TYPEWRITER != true) {
      this.game = new Game(this._keyword);
      console.log("GAME SETUP");
    } else {
      console.log("NO GAME");
      // this.errorsinterface = new Errorsinterface(
      //   this.scene,
      //   5,
      //   this.plane.position.x
      // );
    }
    // add game listeners
    if (this.game) {
      console.log("add game listeners");
      this.game.addEventListener("win", this.handlers.gameWin);
      this.game.addEventListener("gameover", this.handlers.gameOver);
      this.game.addEventListener("ready", this.handlers.gameReady);
    }
  }

  onWheel(e) {
    // console.log("wheel", e);
    // this.resetControlsPosition();
    // this.zoomOut();
  }

  onMouseMove(e) {
    this.mouse.x = (e.clientX / this.size.width) * 2 - 1;
    this.mouse.y = -(e.clientY / this.size.height) * 2 + 1;

    // console.log("NAME", this.INTERSECTED.name);
    if (
      this.INTERSECTED &&
      this.INTERSECTED.parent &&
      this.INTERSECTED.parent.name == "title_letter"
    ) {
      if (this.INTERSECTED.parent.name != this._oldIntersected) {
        this._oldIntersected = this.INTERSECTED.parent.name;
        this.INTERSECTED.parent.roll();
      }
    } else {
      this._oldIntersected = null;
    }
  }

  onMouseClick(e) {
    // if (this.INTERSECTED) console.log(this.INTERSECTED.name);
  }

  onMouseDown(e) {
    // console.log("mouse down", this.INTERSECTED);
    // check for the button
    if (this.INTERSECTED && this.INTERSECTED.name == "playbutton") {
      this.INTERSECTED.parent.highlight(0xffffff);
      // this.INTERSECTED.parent.position.y = -1.5;
    }
  }

  hidePlayButtonAndStart() {
    this.button.hide();
    this.initPlayBack();
  }

  hidePlayButtonAndStartFromTitle() {
    console.log("FROM TITLE");
    GlobalColorSingleton.setNewColors();
    this.changePlaneColorSmoothly();
    this.title.hide();
  }
  onStartIntroSequence() {
    this.initPlayBack();
    this.title.removeEventListener("removed", this.handlers.startIntroSequence);
    this.title.removeEventListener("click", this.handlers.titleStart);
  }

  onMouseUp(e) {
    console.log("mouse up", this.INTERSECTED);
    if (this.INTERSECTED && this.INTERSECTED.name == "playbutton") {
      // //
      // this.INTERSECTED.parent.hide();
      // //
      // this.initPlayBack();

      // this.hidePlayButtonAndStart();
      // this.INTERSECTED.parent.position.y = 0;
      // this.INTERSECTED.parent.highlight(GlobalColorSingleton.color);
      this.hidePlayButtonAndStartFromTitle();
    }
    // click on game letters

    // !!!!!!!!!! ----> change state machine depending on which letter we are clicking :
    //  GAME OR MESSAGE ....
    else if (
      this.INTERSECTED &&
      this.INTERSECTED.parent._type == "letter_block"
    ) {
      this.zoomToElement(this.INTERSECTED.parent);
    }
  }

  onReady() {
    UI.show("pause");
    UI.show("skip");
    UI.show("volume");
    UI.show("about");

    setTimeout(async () => {
      this.controls.dOut(0);
      this.camera.zoom = 1;
      this.camera.updateProjectionMatrix();
      this.saveControlsPosition();

      Statemachine.state = { state: "intro_sequence_playing", value: {} };
      this.playback.start();
      if (!DEBUG) {
        // LOAD NEW TEXTURES FOR THE NEXT ROUND
        const texture = new RemoteTexture(
          `${Config.getTypography}${this.KEYWORD_INDEXES.shift()}`,
          /*`getTypography/${this.KEYWORD_INDEXES.shift()}`,*/
          1
        );
        const ntextures = await texture.load();
        // const img
        this.NEW_TEXTURES = {
          keyword: texture.KEYWORD,
          textures: ntextures,
          asset_id: texture.ASSET_ID,
          link: texture.LINK,
          index: texture.INDEX,
        };
      }
      if (Statemachine.state.state == "intro_sequence_playing")
        this.toolTips.showToolTipForAWhile(7, 5000);
    }, 1000);
  }

  onGameReady() {
    if (this.game) {
      Statemachine.state = { state: "game_ready", value: {} };

      // this.button = new Playbutton();
      // this.button.position.z = -200;
      // this.button.position.x = -60;
      // this.scene.add(this.button);

      this.initialData = JSON.parse(JSON.stringify(this.game.initialData));
      // if shared data is not empty
      if (this.sharedData && this.sharedData.message) {
        this.initialData = Utils.transformMessageIntoTypewriterData(
          this.sharedData.message
        );
      }

      if (Config.language != "en") {
        this.initialData = Utils.transformMessageIntoTypewriterData(
          Utils.translate("Intro", Config.dictionary)
        );
      }

      // SHOW PLAY BUTTON or START DIRECTLY if shared data is available
      // !! ISSUE, because sound won't be activated without user interaction....
      // ----------
      // if (this.sharedData && this.sharedData.index) {
      //   this.INTERSECTED = { name: "playbutton" };
      //   this.onMouseUp(null);
      // } else {
      this.title.showPlayButton();
      // }
    }
  }

  onGameWin(e) {
    // Statemachine.state = { state: "game_done", value: { win: true } };
    // get all the letters
    this.deactivateKeyboard();
    this.deactivateTypeWriter();
    clearTimeout(this.SHOW_UI_TIMEOUT);
    UI.hideAllExcept(["hint", "volume", "about"]);
    UI.keepHidden = true;

    let delay = this.game.activeLetters.length * 200;
    for (let i = 0; i < this.game.activeLetters.length; i++) {
      let letter = this.game.activeLetters[i];
      setTimeout(() => {
        letter.excite();
      }, i * 200);
      delay += i == 1 ? 3000 : 1500;
      setTimeout(() => {
        if (MobileDetector.isMobile || MobileDetector.isTablet) UI.hideAll();
        this.zoomToElement(letter);
      }, delay);
    }
    // ADD ZOOM TO THE LETTERS
    delay += 2000;
    setTimeout(() => {
      this.canContinue = true;
      UI.keepHidden = false;
      this.zoomOut(true, true);
    }, delay);
    if (this.tracker)
      this.tracker.track("GAME_WIN", this.game.KEYWORD_TO_GUESS);
  }

  onGameOver(e) {
    // Statemachine.state = { state: "game_done", value: { win: false } };
    this.deactivateTypeWriter();
    this.canContinue = true;
    clearTimeout(this.SHOW_UI_TIMEOUT);
    UI.hideAllExcept(["hint", "volume", "about"]);
    this.zoomOut(true, false, true);

    // UI.show("replay");
    // UI.hide("continue");
    if (this.tracker)
      this.tracker.track("GAME_OVER", this.game.KEYWORD_TO_GUESS);
  }

  initPlayBack(addWhiteSpace = false) {
    clearTimeout(this.SHOW_UI_TIMEOUT);
    UI.hideAllExcept("about");

    this.playback = new Playback(this.initialData);
    this.playback.addEventListener("play", this.handlers.play);
    this.playback.addEventListener("ready", this.handlers.ready);
    this.playback.addEventListener("complete", this.handlers.complete);
    if (addWhiteSpace) this.playback.ADD_WHITE_SPACE = true;
    this.playback.load();
  }

  // playback actions
  onPlay(data) {
    // console.log(data);
    if (this.CAMERA_ZOOM) {
      this.controls.dOut(0);
      this.resetControlsPosition();
      // //
      // console.log(this.CAMERA_ZOOM);
      this.camera.zoom = this.CAMERA_ZOOM;
      this.camera.updateProjectionMatrix();
    }

    if (data[0] == "+") {
      this.onKeyDown({ key: data[1], _type: "playback" });
    }
    if (data[0] == "-") {
      this.onKeyDown({ key: "Backspace", _type: "playback" });
    }
  }

  playGameSetupSequence(data) {
    // console.log(data);
    if (data[0] == "+") {
      this.onKeyDown({ key: data[1], _type: "playbackGame", clue: data[2] });
    }
    // UNUSED SO FAR
    if (data[0] == "-") {
      this.onKeyDown({
        key: "Backspace",
        _type: "playbackGame",
        clue: data[2],
      });
    }
  }

  onComplete(e) {
    this.playback.removeEventListener("play", this.handlers.play);
    this.playback.removeEventListener("ready", this.handlers.ready);
    this.playback.removeEventListener("complete", this.handlers.complete);
    this.playback.ADD_WHITE_SPACE = false;

    this.KEY_COUNTER_OFFSET = this.KEY_COUNTER;
    UI.hideAllExcept(["hint", "volume", "about"]);
    // if game .... start to generate the hidden word
    if (this.game) {
      this.prepareGame();
      // this.playback.addEventListener(
      //   "playGameSetupSequence",
      //   this.handlers.playGameSetupSequence
      // );
      // this.playback.addEventListener(
      //   "gameSetupIsComplete",
      //   this.handlers.gameSetupIsComplete
      // );
      // this.clueTarget = null;
      // let word = this.game.newWord().split("");
      // let clue = Math.floor(Math.random() * word.length);
      // this.game.clueIndex = clue;
      // UI.set("hint", `${word.length} letters, look carefully`);
      // // generate the word with hidden letters
      // setTimeout(() => {
      //   this.playback.launchHiddenWordSequence(word, clue);
      // }, 1000);
      // focus on the single letter that has the texture
    } else {
      this.playback = null;
    }
  }

  prepareGame() {
    Statemachine.state = { state: "game_preparation", value: {} };
    this.playback.addEventListener(
      "playGameSetupSequence",
      this.handlers.playGameSetupSequence
    );
    this.playback.addEventListener(
      "gameSetupIsComplete",
      this.handlers.gameSetupIsComplete
    );
    this.clueTarget = null;
    let word = this.game.newWord().split("");
    let clue = Math.floor(Math.random() * word.length);
    // safety to avoid the clue to be - or space (clamp to 0)
    if (word[clue] === "-" || word[clue] === " ") clue = Math.max(clue - 1, 0);
    this.game.clueIndex = clue;
    UI.set(
      "hint",
      `${word.length} ${Utils.translate("UI_plural", Config.dictionary)}`
    );
    // VERIFY CAMERA POSITION
    this.verifyCameraPosition(word.length);

    // generate the word with hidden letters
    setTimeout(() => {
      this.playback.launchHiddenWordSequence(word, clue);
    }, 1000);
  }

  verifyCameraPosition(nbr) {
    const totalWordWidth = nbr * 20 + (nbr - 1) * 2;
    // create a small cube to check the width
    const cube = new THREE.Mesh(
      new THREE.BoxGeometry(totalWordWidth, 10, 10),
      new THREE.MeshBasicMaterial({ color: 0xff0000 })
    );
    cube.position.x =
      -100 + this.allLetters.length * 22 + totalWordWidth / 2 - 10;
    cube.position.y = 0;
    cube.position.z = -180;
    cube.visible = false;
    this.scene.add(cube);
    this.otherElementToBeRemoved.push(cube);
    // this.camera.position.z = (totalWordWidth / 2) * 4;
    //
    setTimeout(() => {
      // let element =
      //   this.allLetters[
      //     Math.min(
      //       this.allLetters.length - (Math.floor(nbr / 2) - 2),
      //       this.allLetters.length - 1
      //     )
      //   ];
      /**
       *  if cube  is not centered on the camera, we need to move the camera
       *  not to the middle letter but to the center of the cube minus some value
       */

      const boundingSphere = cube.geometry.boundingSphere;
      const aspect = this.size.width / this.size.height;
      const viewWidth = this.camera.right - this.camera.left;
      const viewHeight = this.camera.top - this.camera.bottom;

      this.controls.target.futurePosition =
        cube.position.x + boundingSphere.radius * 0.37 - 22;
      this.camera.futurePosition =
        cube.position.x + boundingSphere.radius * 0.37 + 22;

      console.log("SCREEN WIDTH", viewWidth, boundingSphere.radius * 2);

      if (boundingSphere.radius * 2 > viewWidth) {
        const ratio = viewWidth / (boundingSphere.radius * 2);
        console.log("ratio", 60 * (1 - ratio), 35 * (1 - ratio));
        this.controls.target.futurePosition -= 60 * (1 - ratio);
        this.camera.futurePosition -= 60 * (1 - ratio);
        if (aspect > 1.0) {
          // if view is wider than it is tall, zoom to fit height
          // this.controls.dOut(viewHeight / (boundingSphere.radius * 2));
          this.camera.zoom =
            (viewHeight / (boundingSphere.radius * 2)) * aspect;
        } else {
          // if view is taller than it is wide, zoom to fit width
          // this.controls.dOut(viewWidth / (boundingSphere.radius * 2));
          this.camera.zoom = (viewWidth / (boundingSphere.radius * 2)) * aspect;
        }
      }

      // Don't forget this
      this.camera.updateProjectionMatrix();
      //
    }, nbr * 300 + 2000);
  }

  onCompleteGameSetup(e) {
    Statemachine.state = { state: "game_is_playable", value: {} };
    this.game.PLAY_MODE = true;
    // this.saveControlsPosition();
    // this.activateTypeWriter();
    this.game.getActiveLetters(this.allLetters);
    this.ZOOM_TIMEOUT = setTimeout(() => {
      this.zoomToElement(this.clueTarget);
      UI.show("hint");
      UI.show("zoomout");
      UI.show("back");

      this.ZOOM_TIMEOUT = null;
      this.activateTypeWriter();
      // active mobile keyboard
      this.activateKeyboard();
    }, 3000);
    // add errors interface
    setTimeout(() => {
      this.errorsinterface = new Errorsinterface(
        this.scene,
        5,
        /* this.plane.position.x*/
        this.otherElementToBeRemoved[0].position.x
      );
    }, 1000);
  }

  onUIActions(action) {
    if (this.tracker) this.tracker.track("UI_TOGGLE", action);
    switch (action) {
      case "zoomout":
        // clearTimeout(this.TWEEN_ZOOM);
        if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        // clearTimeout(this.TWEEN_ZOOM);
        this.zoomOut();
        // // Statemachine.state = { state: "game_is_playable", value: {} };

        break;
      case "share":
        this.onShare(null);
        break;
      case "zoomin":
        // clearTimeout(this.TWEEN_ZOOM);
        if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        this.zoomIn();
        Statemachine.state = { state: "game_zoomed", value: {} };
        break;
      case "continue":
      case "replay":
        // this.game.newWord();
        if (this.canContinue) {
          GlobalColorSingleton.setNewColors();
          this.removePastLetters();
          this.changePlaneColorSmoothly();
          // this.draggableModal.hide();
          this.finishModal.hide();
          this.canContinue = false;
          this.game.PLAY_MODE = false;
          if (this.NEW_TEXTURES) {
            // translate word here
            this.game.KEYWORD_TO_GUESS = Utils.translate(
              this.NEW_TEXTURES.keyword,
              Config.dictionary
            );
            this.ALL_TEXTURES = this.NEW_TEXTURES.textures;
            this.ASSET_ID = this.NEW_TEXTURES.asset_id;
            this.LINK = this.NEW_TEXTURES.link;
            this._index = this.NEW_TEXTURES.index;

            // GlobalColorSingleton.getColorFromImage(
            //   this.NEW_TEXTURES.textures.image
            // );
            // this.draggableModal.updateContent(
            //   this.ASSET_ID,
            //   this.game.KEYWORD_TO_GUESS
            // );
            this.finishModal.updateContent(
              this.ASSET_ID,
              this.game.KEYWORD_TO_GUESS,
              this.LINK
            );
          }
          /**
           *
           *  UPDATE TEXTURES AND INDICES
           *  COLOR BACKGROUND TOO....
           *
           */
          this.initialData = JSON.parse(JSON.stringify(this.game.initialData));
          let message = null;
          // setup message depending on the game win or lose
          if (
            Statemachine.state.state === "game_done" &&
            Statemachine.state.value.win
          ) {
            console.log("MESSAGE TO WINNER", Statemachine.state);
            // message =
            //   this.game.extraData.winning[
            //     Math.floor(Math.random() * this.game.extraData.winning.length)
            //   ];
            message = Utils.translate(
              this.game.extraDataKeys.winning[
                Math.floor(
                  Math.random() * this.game.extraDataKeys.winning.length
                )
              ],
              Config.dictionary
            );
          } else if (!Statemachine.state.value.win) {
            console.log("MESSAGE TO LOOSER", Statemachine.state);
            // message =
            //   this.game.extraData.losing[
            //     Math.floor(Math.random() * this.game.extraData.losing.length)
            //   ];
            message = Utils.translate(
              this.game.extraDataKeys.losing[
                Math.floor(
                  Math.random() * this.game.extraDataKeys.losing.length
                )
              ],
              Config.dictionary
            );
          }
          this.initialData = Utils.transformMessageIntoTypewriterData(message);
          this.initPlayBack(true);
        }
        break;
      case "pause":
        Statemachine.state = { state: "intro_sequence_playing", value: {} };
        if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        this.playback.pause();
        UI.hide("pause");
        this.SHOW_UI_TIMEOUT = setTimeout(() => {
          UI.show("play");
          UI.show("back");
          this.toolTips.showToolTipForAWhile(1, 3000);
          Statemachine.state = { state: "detailed_view", value: {} };
        }, 1000);
        // zoom to element
        this.zoomToElement(this._playTargetElement.element);

        break;
      case "pauseFreeze":
        Statemachine.state = { state: "intro_sequence_playing", value: {} };
        if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        this.playback.pause();
        break;
      case "playResume":
        this.playback.start();
        break;
      case "play":
        // if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        this.playback.start();
        UI.hideAllExcept(["hint", "volume", "about"]);
        this.SHOW_UI_TIMEOUT = setTimeout(() => {
          UI.show("pause");
          UI.show("skip");
        }, 1000);
        // Statemachine.state = { state: "intro_sequence_playing", value: {} };
        break;
      case "back":
        // clearTimeout(this.TWEEN_ZOOM);
        // this.killAllTweens();
        if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        Statemachine.state = { state: "detailed_view", value: {} };
        const newIndex = this._playTargetElement.index - 1;
        const element = this.onlyLettersWithTexture[newIndex];
        this._playTargetElement = { element: element, index: newIndex };
        if (newIndex >= 0) {
          this.zoomToElement(this._playTargetElement.element);
        }
        // UI THINGS
        if (newIndex < this.onlyLettersWithTexture.length - 1) {
          UI.show("forward");
        } else {
          UI.hide("forward");
        }
        if (newIndex <= 0) {
          UI.hide("back");
        }

        break;
      case "forward":
        // clearTimeout(this.TWEEN_ZOOM);
        if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        Statemachine.state = { state: "detailed_view", value: {} };
        const newIndex2 = this._playTargetElement.index + 1;
        if (newIndex2 <= this.onlyLettersWithTexture.length - 1) {
          const element2 = this.onlyLettersWithTexture[newIndex2];
          this._playTargetElement = { element: element2, index: newIndex2 };
          this.zoomToElement(this._playTargetElement.element);
        }
        if (newIndex2 == this.onlyLettersWithTexture.length - 1) {
          UI.hide("forward");
        }
        if (newIndex2 > 0) {
          UI.show("back");
        }
        break;

      case "link":
        if (this.AXL_IS_RUNNING) {
          this.axl.sendMessage(
            AxL.ChildToHost.NAVIGATE,
            "partner/frogs-friends"
          );
        } else {
          console.log("LINK ACTIVATE");
        }
        break;
      case "volume":
        if (!AudioEffects.mute) {
          AudioEffects.mute = true;
          UI.set("volume", "volume_off", "unmute");
        } else {
          AudioEffects.mute = false;
          UI.set("volume", "volume_up", "mute");
        }
        break;
      case "skip":
        Statemachine.state = { state: "intro_sequence_skip", value: {} };
        if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
        this.playback.skip();
        this.toolTips.hideAllToolTips();
        break;
      case "about":
        this.aboutPage.show();
        break;
    }
  }

  onNavigateToAsset(data) {
    if (this.AXL_IS_RUNNING) {
      this.axl.sendMessage(AxL.ChildToHost.NAVIGATE, `${data}`);
      this.tracker.track("LEARN_MORE", data);
    } else {
      console.log(data);
    }
  }

  onShare(e) {
    if (this.AXL_IS_RUNNING) {
      this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
        index: this._index,
        message: "Can you guess that word by looking at the letters ?",
      });
      this.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title: "Can you guess the hidden word with XYZ TOY ?",
      });
      this.tracker.track("SHARE");
    } else {
      // Utils.save(
      //   JSON.stringify(this.recorder.values),
      //   "recordings.json",
      //   "application/json"
      // );
    }
    //  this.recorder.reset();
  }

  onKeyDown(e) {
    // e.preventDefault();
    if (this.TWEEN_ZOOM) {
      console.log("RESET CAMERA HERE");
      this.TWEEN_ZOOM.stop();
      this.TWEEN_ZOOM = null;

      this.controls.dOut(0);
      this.resetControlsPosition();
      // //
      // console.log(this.CAMERA_ZOOM);
      this.camera.zoom = this.CAMERA_ZOOM;
      this.camera.updateProjectionMatrix();
      // this.zoomOut();
      if (this.game.PLAY_MODE) {
        UI.hide("zoomout");
        this.SHOW_UI_TIMEOUT = setTimeout(() => {
          UI.show("zoomin");
        }, 1000);
      }
    } else {
      console.log("CAMERA IS NOT RESET!");
    }
    if (this.ZOOM_TIMEOUT) {
      clearTimeout(this.ZOOM_TIMEOUT);
      this.ZOOM_TIMEOUT = null;
      UI.show("hint");
    }

    if (e.key == "Enter") {
      if (this.game && !this.game.HAS_STARTED) {
        this.game.HAS_STARTED = true;
        this.hidePlayButtonAndStart();
      } else if (this.canContinue) {
        this.onUIActions("continue");
      }
      return false;
    }

    // save the recording as json file
    if (e.key == "Tab") {
      /**
       * TOOL TO RECORD A SENTENCE
       */

      // if (this.AXL_IS_RUNNING) {
      //   this.axl.sendMessage(
      //     AxL.ChildToHost.SET_URL_PARAMS,
      //     this.recorder.values
      //   );
      //   this.axl.sendMessage(AxL.ChildToHost.SHARE, {
      //     title: "I have a message for you",
      //   });
      // } else {
      //   Utils.save(
      //     JSON.stringify(this.recorder.values),
      //     "recordings.json",
      //     "application/json"
      //   );
      // }
      // this.recorder.reset();

      // this.onShare(null);
      if (BASIC_TYPEWRITER) {
        Utils.save(
          JSON.stringify(this.recorder.values),
          "recordings.json",
          "application/json"
        );
        this.recorder.reset();
        this.title.rolling();
      }

      // this.onGameWin(null);
      return;
    }
    if (this.specialKeys.includes(e.key)) return;

    let shift = null;

    // // push letter in the globalletters array
    // shift = new Letter(this.ALL_TEXTURES);
    // shift.position.x = -100 + this.allLetters.length * 22;
    // shift.position.z = shift.origineZ =
    //   -180 + 0 * 10 + this.noise2D(0, this.allLetters.length) * 10;
    // this.scene.add(shift);
    // this.allLetters.push(shift);

    if (!this.game || !this.game.PLAY_MODE) {
      if (e.key == "Backspace") {
        shift = this.allLetters.pop();
        // this.allLetters.unshift(shift);

        this.KEY_COUNTER--;
        if (!e._type) this.recorder.remove();
      } else {
        // if (!this.game || !this.game.PLAY_MODE) {

        // shift = this.allLetters.shift();
        // this.allLetters.push(shift);
        // push letter in the globalletters array
        shift = new Letter(this.ALL_TEXTURES);
        shift.position.x = -100 + this.allLetters.length * 22;
        shift.position.z = shift.origineZ =
          -180 + 0 * 10 + this.noise2D(0, this.allLetters.length) * 10;
        this.scene.add(shift);
        this.allLetters.push(shift);

        this.KEY_COUNTER++;

        // recorder fonction....
        if (!e._type) this.recorder.add(e.key);
        // if is the game say that the letters are in the game or the message
        if (e._type == "playbackGame") shift.isInGame = true;
      }

      if (
        e.key != "Backspace" &&
        (e._type != "playbackGame" ||
          e.clue == this.allLetters.length - this.KEY_COUNTER_OFFSET - 1)
      ) {
        shift.set(e.key, e._type == "playbackGame" ? true : false);
        this.clueTarget = shift;
      } else if (e._type == "playbackGame" && e.key != "-") {
        shift.stayVertical();
        shift.fillUpWithSingleColor();
      } else if (e._type == "playbackGame" && e.key == "-") {
        shift.stayVertical();
        shift.set(e.key, e._type == "playbackGame" ? true : false);
        this.game.keyPressed(e);
      }

      // this.targetElement = this.allLetters[this.allLetters.length - 2].cube;
      this.targetElement = shift;
      if (!shift.NO_TEXTURE && e._type != "playbackGame") {
        this._playTargetElement = {
          element: shift,
          index: this.onlyLettersWithTexture.length,
        };
        this.onlyLettersWithTexture.push(shift);
      }

      // for any key press
      // tween the cube up or down
      // depending on the current position
      if (e.key != " ") {
        if (shift.position.y >= 0 || e.key == "Backspace") {
          shift.hide();
        } else if (shift.position.y < 0) {
          shift.jump();
        }
      }

      // move camera and light
      if (this.KEY_COUNTER > 5 || this.CANCEL_BLOCKER) {
        // if (this.KEY_COUNTER - this.KEY_COUNTER_OFFSET > 5)
        //   UI.showShareButton();
        this.moveCameraAndLightOnX(-50);
        this.CANCEL_BLOCKER = true;
      }
    } else {
      this.keyPressedDuringGame(e);
    }
  }

  /**
   *
   * GAME INTERACTION
   */

  keyPressedDuringGame(e) {
    this.controls.dOut(0);
    this.resetControlsPosition();
    //
    this.camera.zoom = this.CAMERA_ZOOM;
    this.camera.updateProjectionMatrix();

    // check for the game....
    let key = null;
    if (this.game && !e._type) {
      key = this.game.keyPressed(e);
      //
      if (!this.hasUsedKeyboard) {
        UI.hide("keyboardMessage");
        this.hasUsedKeyboard = true;
      }
    }

    let letter = null;
    if (key.length > 0) {
      letter = this.game.getLetterByIndex(key[1]);
      letter.updateTexture(key[0]);
      // animation
      letter.roll();
      this.lastLetter = letter;
    } else {
      this.errorsinterface.error();
    }
  }

  updateRaycaster() {
    // update the picking ray with the camera and mouse position
    this.raycaster.setFromCamera(this.mouse, this.camera);
    // calculate objects intersecting the picking ray
    const intersects = this.raycaster.intersectObjects(
      this.scene.children,
      true
    );
    if (intersects.length > 0) {
      if (this.INTERSECTED != intersects[0].object) {
        this.INTERSECTED = intersects[0].object;
      }
    } else {
      this.INTERSECTED = null;
    }
  }

  draw() {
    if (!this.PAUSE) {
      // update orbit controls

      this.controls.update();
      this.lightHelper.update();
      this.renderer.render(this.scene, this.camera);
      // update tween
      TWEEN.update();
      this.updateCameraAndLightPosition();

      // update and check raycaster
      this.updateRaycaster();

      // update title
      if (this.title) this.title.update();

      // update mobile keyboard
      if (this.mobileKeyboard) this.mobileKeyboard.update();

      requestAnimationFrame(this.draw.bind(this));
    }
  }

  updateCameraAndLightPosition() {
    // update camera position with a tween
    if (this.camera.position.x != this.camera.futurePosition) {
      this.camera.position.x =
        this.camera.position.x +
        (this.camera.futurePosition - this.camera.position.x) * this.speed;
      // update light position
      this.light.position.x =
        this.light.position.x +
        (this.light.futurePosition - this.light.position.x) * this.speed;
      // update light target position
      this.lightTarget.position.x =
        this.lightTarget.position.x +
        (this.lightTarget.futurePosition - this.lightTarget.position.x) *
          this.speed;
      // update plane position
      this.plane.position.x =
        this.plane.position.x +
        (this.plane.futurePosition - this.plane.position.x) * this.speed;
      // update controls target position
      this.controls.target.x =
        this.controls.target.x +
        (this.controls.target.futurePosition - this.controls.target.x) *
          this.speed;
    }
  }

  // loadAudios() {
  //   this.audios = [];
  //   for (let i = 1; i <= 10; i++) {
  //     // add leading zero
  //     let num = i.toString().padStart(2, "0");
  //     this.audios.push(new Audio(`./sound/pops_${num}.mp3`));
  //   }
  // }

  // loadSingleAudio(url) {
  //   return new Promise((resolve, reject) => {
  //     const audio = new Audio(url);
  //     audio.addEventListener("canplaythrough", () => {
  //       resolve(audio);
  //     });
  //   });
  // }
  // -80
  moveCameraAndLightOnX(offset = -20) {
    // if (this.IS_ZOOMING) return;
    this.camera.futurePosition = this.targetElement.position.x + 30 + offset;
    this.light.futurePosition = this.targetElement.position.x + offset;
    this.controls.target.futurePosition =
      this.targetElement.position.x - 14 + offset;
    this.lightTarget.futurePosition = this.targetElement.position.x + offset;
    this.plane.futurePosition = this.targetElement.position.x + offset;
  }

  saveControlsPosition() {
    this.CONTROLS_TARGET_FUTUREPOSITION = this.controls.target.futurePosition;
    this.CAMERA_FUTUREPOSITION = this.camera.futurePosition;
    this.CAMERA_ZOOM = this.camera.zoom;
    // add light move
    this.LIGHT_FUTUREPOSITION = this.light.futurePosition;
    this.LIGHT_TARGET_FUTUREPOSITION = this.lightTarget.futurePosition;
    // add plane move
    this.PLANE_FUTUREPOSITION = this.plane.futurePosition;
  }

  resetControlsPosition() {
    if (this.CONTROLS_TARGET_FUTUREPOSITION) {
      this.controls.target.futurePosition = this.CONTROLS_TARGET_FUTUREPOSITION;
      this.camera.futurePosition = this.CAMERA_FUTUREPOSITION;

      // add light move
      this.light.futurePosition = this.LIGHT_FUTUREPOSITION;
      this.lightTarget.futurePosition = this.LIGHT_TARGET_FUTUREPOSITION;

      // add plane move
      this.plane.futurePosition = this.PLANE_FUTUREPOSITION;

      // setTimeout(() => {
      //   this.camera.zoom = this.CAMERA_ZOOM;
      //   // Don't forget this
      //   this.camera.updateProjectionMatrix();
      // }, 1000);
    }
  }

  zoomToElement(element) {
    // this.targetElement = element;
    // this.camera.futurePosition = this.targetElement.position.z;
    // this.light.futurePosition = this.targetElement.position.z;
    // this.controls.target.futurePosition = this.targetElement.position.z;
    // this.lightTarget.futurePosition = this.targetElement.position.z;
    // console.log("zoom to element", element);
    // this.IS_ZOOMING = true;

    // console.log("zoom0 : ", this.camera.zoom, this.controls.camera);
    console.log("**STATE**", Statemachine.state.state);
    if (
      this.camera.zoom != 4 &&
      (Statemachine.state.state == "game_is_playable" ||
        Statemachine.state.state == "intro_sequence_playing")
    )
      this.saveControlsPosition();

    let zoomValue = new THREE.Vector3(1, 0, 0);
    if (element) {
      // clearTimeout(this.TWEEN_ZOOM);
      if (this.TWEEN_ZOOM) this.TWEEN_ZOOM.stop();
      this.TWEEN_ZOOM = new TWEEN.Tween(zoomValue)
        .to({ x: 1.05 }, 2000)
        .easing(TWEEN.Easing.Linear.None)
        .onUpdate(() => {
          this.controls.target.futurePosition = element.position.x;
          this.camera.futurePosition = element.position.x;
          // console.log(zoomValue.x);
          this.controls.dOut(zoomValue.x);
          // --> calculate light new position without offset ??
          this.light.futurePosition = element.position.x;
          this.lightTarget.futurePosition = element.position.x;
          // should also move the plane
          this.plane.futurePosition = element.position.x;
        })
        .onComplete(() => {
          this.TWEEN_ZOOM = null;
          if (element.isInGame) {
            Statemachine.state = { state: "game_zoomed", value: {} };
          } else {
            Statemachine.state = { state: "detailed_view", value: {} };
          }
        })
        .start();
    }
    // this.controls.update();
    if (this.game.PLAY_MODE) {
      UI.hide("zoomin");
      clearTimeout(this.SHOW_UI_TIMEOUT);
      this.SHOW_UI_TIMEOUT = setTimeout(() => {
        UI.show("zoomout");
      }, 1000);
    }
  }

  zoomOut(showShare = false, showContinue = false, showReplay = false) {
    // if (this.TWEEN_ZOOM) return;
    if (this.TWEEN_ZOOM) {
      this.TWEEN_ZOOM.stop();
      this.TWEEN_ZOOM = null;
    }
    const zoomValue = { x: 1, y: this.camera.zoom };
    // have to set it to 0 !!!!
    this.TWEEN_ZOOM = new TWEEN.Tween(zoomValue)
      .to({ x: 0, y: this.CAMERA_ZOOM }, 900)
      .easing(TWEEN.Easing.Linear.None)
      .onUpdate(() => {
        this.controls.dOut(zoomValue.x);
        this.resetControlsPosition();
        // add camera zoom if needed
        this.camera.zoom = zoomValue.y;
        this.camera.updateProjectionMatrix();
      })
      .onComplete(() => {
        // Statemachine.state = { state: "game_is_playable", value: {} };
      })
      .start();

    UI.hideAllExcept(["hint", "volume", "about"]);

    // if (showShare)
    //   setTimeout(() => {
    //     // UI.show("share");
    //   }, 1000);
    if (showContinue || showReplay) {
      setTimeout(() => {
        setTimeout(() => {
          UI.hideAll();
        }, 1000);
        // UI.hideAll();
        // UI.show("continue");
        // UI.show("link");
        // this.draggableModal.show();
        // UI.hideAll();
        // document.getElementById("finishMessage").classList.add("zoomIn");
        // document.getElementById("finishMessage").classList.remove("hidden");
        // this.finishModal.keywordMessage.textContent = "Congratulations";
        this.finishModal.show();
        Statemachine.state = { state: "game_done", value: { win: true } };
      }, 1000);
    }
    // if (showReplay) {
    //   // UI.hideAll();
    //   setTimeout(() => {
    //     // UI.show("replay");
    //     // UI.hideAll();
    //     // this.finishModal.keywordMessage.textContent = "Sorry";
    //     this.finishModal.show();
    //     Statemachine.state = { state: "game_done", value: { win: false } };
    //   }, 1000);
    // }

    if (!showShare && !showContinue) {
      UI.hide("zoomout");
      this.SHOW_UI_TIMEOUT = setTimeout(() => {
        UI.show("zoomin");
        UI.show("back");
        UI.hide("forward");
        Statemachine.state = { state: "game_is_playable", value: {} };
      }, 1000);
    }
    // else {
    //   UI.hide("zoomout");
    //   UI.hide("zoomin");
    // }
  }

  zoomIn() {
    if (this.game.PLAY_MODE && this.game.correctLetters.length == 1) {
      // get clue
      const letter = this.game.getLetterByIndex(this.game.clueIndex);
      this.zoomToElement(letter);
    } else if (this.game.PLAY_MODE && this.lastLetter) {
      this.zoomToElement(this.lastLetter);
    }
  }

  resetPosition(offset = -20) {
    this.camera.futurePosition = 30 + offset;
    this.light.futurePosition = offset;
    this.controls.target.futurePosition = -14 + offset;
    this.lightTarget.futurePosition = offset;
    this.plane.futurePosition = offset;

    //
    setTimeout(() => {
      this.camera.zoom = 1;
      this.camera.updateProjectionMatrix();
    }, 400);
  }

  removePastLetters() {
    for (let i = 0; i < this.allLetters.length; i++) {
      setTimeout(() => {
        this.allLetters[i].kill();
      }, Math.random() * 200);
    }
    for (let i = 0; i < this.errorsinterface.errors.length; i++) {
      setTimeout(() => {
        this.errorsinterface.errors[i].kill();
      }, Math.random() * 200);
    }
    for (let i = 0; i < this.otherElementToBeRemoved.length; i++) {
      this.otherElementToBeRemoved[i].geometry.dispose();
      this.scene.remove(this.otherElementToBeRemoved[i]);
    }

    setTimeout(() => {
      for (let i = 0; i < this.allLetters.length; i++) {
        // this.scene.remove(this.allLetters[i]);
        this.allLetters[i].geometry.dispose();
        // this.allLetters[i].material.dispose();
        this.scene.remove(this.allLetters[i]);
      }
      for (let i = 0; i < this.errorsinterface.errors.length; i++) {
        this.errorsinterface.errors[i].geometry.dispose();
        this.scene.remove(this.errorsinterface.errors[i]);
      }
      this.scene.remove(this.errorsinterface.errors_group);
      this.allLetters = [];
      this.onlyLettersWithTexture = [];
      this.otherElementToBeRemoved = [];
      this.KEY_COUNTER = 0;
      this.renderer.renderLists.dispose();
      //
      // this.camera.zoom = 1;
      // this.camera.updateProjectionMatrix();
      this.resetPosition();
    }, 1000);
  }

  changePlaneColorSmoothly() {
    const color = new THREE.Color(this.planeMaterial.color.getHexString());
    const rgb = GlobalColorSingleton.planeColorRGB;
    new TWEEN.Tween(color)
      .to({ r: rgb[0], g: rgb[1], b: rgb[2] }, 1000)
      .easing(TWEEN.Easing.Linear.None)
      .onUpdate(() => {
        this.plane.material.color = color;
        // console.log(color);
        document.body.style.backgroundColor = `rgb(${color.r * 255},${
          color.g * 255
        },${color.b * 255})`;
      })
      .start();
  }

  activateKeyboard() {
    // this.keyboard_activator.value = "";
    // this.keyboard_activator.focus();
  }
  deactivateKeyboard() {
    // this.keyboard_activator.blur();
  }

  // USER INTERACTION ACTIVATION + DEACTIVATION
  activateTypeWriter() {
    document.addEventListener("keydown", this.handlers.down);
    if (this.mobileKeyboard) this.mobileKeyboard.show();
    if (this.hasUsedKeyboard) return;
    UI.show("keyboardMessage");
  }

  deactivateTypeWriter() {
    document.removeEventListener("keydown", this.handlers.down);
    if (this.mobileKeyboard) this.mobileKeyboard.hide();
  }
  // killAllTweens() {
  //   for (let i = 0; i < this.ALL_TWEENS.length; i++) {
  //     this.ALL_TWEENS[i].stop();
  //     clearTimeout(this.ALL_TWEENS[i]);
  //   }
  //   this.ALL_TWEENS = [];
  // }
}
